import { render, staticRenderFns, recyclableRender, components } from "./coupon-details.vue?vue&type=template&id=458d5766&scoped=true&"
var renderjs
import script from "./coupon-details.vue?vue&type=script&lang=js&"
export * from "./coupon-details.vue?vue&type=script&lang=js&"
import style0 from "./coupon-details.vue?vue&type=style&index=0&id=458d5766&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../soft/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "458d5766",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/coupon-details/coupon-details.vue"
export default component.exports